import { _post, _get, _delete } from "./Axios";

export default class EmployeesApi {
  static get(id = null) {
    if (id == null) {
      return _get("masterdata/employee/");
    } else {
      return _get("masterdata/employee/" + id);
    }
  }
  static getByKeyword(keyword = "") {
    return _get("masterdata/employee/?keyword=" + keyword);
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("masterdata/employee?" + params);
  }
  static searchOwner(key = null) {
    return _get("masterdata/employee/searchowner?key=" + key);
  }
  static post(data) {
    return _post("masterdata/employee/", data);
  }
  static update(id, data) {
    return _post("masterdata/employee/" + id, data);
  }
  static changePassword(id, data) {
    return _post("masterdata/employee/" + id + "/changepassword", data);
  }
  static delete(id) {
    return _delete("masterdata/employee/" + id);
  }
  static check_token(data) {
    return _post("auth/checktoken/", data);
  }
  static getGroups() {
    return _get("masterdata/employee/groups/");
  }
  static synchronize(data) {
    return _post("masterdata/employee/synchronize/", data);
  }
  static getsynchronize(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("masterdata/employee/synchronize/detail?" + params);
  }
  static checkSyncTasks() {
    return _get("celery-tasks/");
  }
  static checkSyncProgress(task_id) {
    return _get("celery-progress/" + task_id, null, true);
  }
}
